import { StyleSheet, Platform, Dimensions } from 'react-native';
import { COLORS, SPACING, BORDER_RADIUS } from './constants';

const { width: SCREEN_WIDTH } = Dimensions.get('window');
const isIOSMobile = Platform.OS === 'ios' && SCREEN_WIDTH < 768;

export const styles = StyleSheet.create({
  container: {
    ...Platform.select({
      ios: {
        width: '100%',
        minHeight: 600,
      },
      default: {
        flex: 1,
      },
    }),
    paddingHorizontal: SPACING.md,
    paddingVertical: SPACING.md,
  },
  controlBar: {
    flexDirection: 'row',
    justifyContent: isIOSMobile ? 'space-between' : 'flex-start',
    alignItems: 'center',
    paddingHorizontal: isIOSMobile ? SPACING.lg : SPACING.md,
    paddingVertical: isIOSMobile ? SPACING.xs : SPACING.md,
    marginBottom: SPACING.md,
    gap: isIOSMobile ? 4 : (Platform.OS === 'ios' ? 10 : 16),
  },
  rightControlSection: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: isIOSMobile ? 2 : SPACING.sm,
  },
  viewSwitcher: {
    flexDirection: 'row',
    backgroundColor: COLORS.backgroundLight,
    borderRadius: BORDER_RADIUS.md,
    padding: SPACING.xs,
    height: 32,
    minWidth: isIOSMobile ? 90 : (Platform.OS === 'ios' ? 180 : undefined),
  },
  viewButton: {
    flex: 1,
    paddingHorizontal: isIOSMobile ? 6 : SPACING.md,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: BORDER_RADIUS.md,
    minWidth: isIOSMobile ? 65 : 75,
  },
  viewButtonActive: {
    backgroundColor: COLORS.backgroundLightAlt,
    borderWidth: 1,
    borderColor: '#005cbc',
  },
  viewButtonText: {
    fontSize: 14,
    fontWeight: '400',
    color: COLORS.textSecondary,
  },
  viewButtonTextActive: {
    fontWeight: '700',
  },
  navigationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: isIOSMobile ? 0 : SPACING.sm,
    marginBottom: SPACING.sm,
  },
  navChevron: {
    width: isIOSMobile ? 28 : 32,
    height: isIOSMobile ? 28 : 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  chevronText: {
    fontSize: 20,
    fontWeight: '600',
    color: COLORS.textSecondary,
  },
  monthYearText: {
    fontSize: isIOSMobile ? 12 : 14,
    fontWeight: '400',
    flexShrink: 1,
    // marginLeft: SPACING.md,
  },
  // Monthly view styles
  weekdaysRow: {
    flexDirection: 'row',
    marginBottom: SPACING.md,
    paddingHorizontal: 8,
    paddingBottom: 8,
    ...Platform.select({
      ios: {
        width: '100%',
      },
    }),
  },
  weekdayCell: {
    flex: 1,
    alignItems: 'flex-start',
    paddingVertical: SPACING.sm,
    marginLeft: SPACING.lg,
    ...Platform.select({
      ios: {
        minWidth: 0,
        width: '14.28%',
      },
    }),
  },
  weekdayText: {
    fontSize: 14,
    fontWeight: '400',
  },
  calendarGrid: {
    ...Platform.select({
      ios: {
        width: '100%',
        flexDirection: 'column',
        position: 'relative',
      },
      default: {
        flex: 1,
      },
    }),
    paddingHorizontal: 8,
    paddingBottom: 8,
    shadowColor: 'rgba(0,94,192,0.08)',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 1,
    shadowRadius: 24,
    elevation: 4,
    borderRadius: 8,
  },
  week: {
    flexDirection: 'row',
    marginBottom: SPACING.sm,
    ...Platform.select({
      ios: {
        width: '100%',
        position: 'relative',
        zIndex: 1,
      },
    }),
    gap: SPACING.sm,
  },
  dayCell: {
    flex: 1,
    ...Platform.select({
      ios: {
        minWidth: 0,
        width: '14.28%',
        position: 'relative',
      },
    }),
    height: 120,
    borderWidth: 1,
    padding: SPACING.md,
    backgroundColor: COLORS.background,
  },
  todayCell: {
    backgroundColor: '#f5f5f5',
  },
  dayHeader: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: SPACING.xs,
  },
  dayNumber: {
    fontSize: 14,
    fontWeight: '400',
    minWidth: 24,
    textAlign: 'center',
  },
  todayNumber: {
    fontWeight: 'bold',
  },
  eventsContainer: {
    flex: 1,
    ...Platform.select({
      ios: {
        overflow: 'hidden',
      },
    }),
  },
  // Weekly view styles
  weeklyContainer: {
    ...Platform.select({
      ios: {
        width: '100%',
        flexDirection: 'column',
        position: 'relative',
      },
      default: {
        flex: 1,
      },
    }),
    paddingHorizontal: 8,
    paddingBottom: 8,
    shadowColor: 'rgba(0,94,192,0.08)',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 1,
    shadowRadius: 24,
    elevation: 4,
    borderRadius: 8,
  },
  weeklyHeaderRow: {
    flexDirection: 'row',
    marginBottom: SPACING.sm,
    gap: SPACING.sm,
    ...Platform.select({
      ios: {
        width: '100%',
      },
    }),
  },
  weeklyHeaderCell: {
    flex: 1,
    height: 40,
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginLeft: SPACING.md,
    ...Platform.select({
      ios: {
        minWidth: 0,
        width: '14.28%',
      },
    }),
  },
  weeklyDayName: {
    fontSize: 14,
    fontWeight: '400',
  },
  // Mobile weekly view styles
  weeklyDayGroup: {
    width: '100%',
    marginBottom: 0,
  },
  weeklyDayNameContainer: {
    height: 40,
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingHorizontal: SPACING.md,
  },
  weeklyGrid: {
    flex: 1,
    flexDirection: 'column',
  },
  weeklyDayCell: {
    width: '100%',
    minHeight: 120,
    borderWidth: 1,
    padding: SPACING.md,
    backgroundColor: COLORS.background,
    marginBottom: 0,
    ...Platform.select({
      ios: {
        position: 'relative',
      },
    }),
  },
  weeklyDateSection: {
    alignItems: 'flex-start',
    marginBottom: SPACING.sm,
    justifyContent: 'flex-start',
    height: 19,
    flexDirection: 'row',
  },
  // Web weekly view styles
  weeklyGridHorizontal: {
    flex: 1,
    flexDirection: 'row',
    gap: SPACING.sm,
    ...Platform.select({
      ios: {
        width: '100%',
        position: 'relative',
      },
    }),
  },
  weeklyDayCellWeb: {
    flex: 1,
    height: 120,
    borderWidth: 1,
    borderRadius: BORDER_RADIUS.sm,
    padding: SPACING.md,
    backgroundColor: COLORS.background,
    ...Platform.select({
      ios: {
        minWidth: 0,
        width: '14.28%',
        position: 'relative',
      },
    }),
  },
  weeklyDateSectionWeb: {
    alignItems: 'flex-start',
    marginBottom: SPACING.sm,
    justifyContent: 'flex-start',
    height: 19,
    position: 'relative',
  },
  weeklyDateNumberWeb: {
    fontSize: 14,
    fontWeight: '400',
    textAlign: 'left',
  },
  todayDateCircle: {
    width: 28,
    height: 19,
    borderRadius: BORDER_RADIUS.lg,
    borderWidth: 2,
    borderColor: COLORS.primary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  todayDateCircleMobile: {
    width: 28,
    height: 19,
    borderRadius: BORDER_RADIUS.lg,
    borderWidth: 2,
    borderColor: COLORS.primary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  todayDot: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: COLORS.primary,
    marginRight: SPACING.md,
    marginBottom: SPACING.sm,
  },
  weeklyDateNumber: {
    fontSize: 14,
    fontWeight: '400',
    textAlign: Platform.OS === 'ios' ? 'left' : 'center',
    ...Platform.select({
      ios: {
        paddingLeft: SPACING.md,
      },
    }),
  },
  weeklyDateNumberToday: {
    fontWeight: 'bold',
  },
  weeklyEventsContainer: {
    flex: 1,
    ...Platform.select({
      ios: {
        overflow: 'hidden',
      },
    }),
  },
  eventBadge: {
    paddingHorizontal: 6,
    paddingVertical: 0,
    borderRadius: BORDER_RADIUS.sm,
    marginBottom: SPACING.xs,
    ...Platform.select({
      ios: {
        minHeight: 20,
        width: '100%',
      },
    }),
  },
  eventBadgeSmall: {
    paddingHorizontal: 4,
    paddingVertical: 2,
    marginBottom: 1,
  },
  eventText: {
    fontSize: 12,
    fontWeight: '500',
  },
  eventTextSmall: {
    fontSize: 10,
  },
});
